import React from 'react';
import { motion } from 'framer-motion';
import { CircleAlert, Inbox, Mail } from 'lucide-react';
import { useLanguage } from '../../i18n';

const supportItems = [
    { title: 'Kênh Email', desc: 'Ưu tiên hỗ trợ kỹ thuật & yêu cầu cập nhật theo gói.', meta: 'Thời gian phản hồi: 4-24h' },
    { title: 'Giám sát uptime', desc: 'Theo dõi tự động downtime & cảnh báo bất thường.', meta: '24/7 (gói mở rộng)' },
    { title: 'Tối ưu hiệu suất', desc: 'Định kỳ phân tích Core Web Vitals & tối ưu caching.', meta: 'Hàng tháng / quý' },
    { title: 'Bảo mật & vá lỗi', desc: 'Quét malware, cập nhật bản vá plugin / core.', meta: 'Theo chu kỳ & khi có cảnh báo' }
];

const Support = () => {
    const { language, t } = useLanguage();
    const localizedItems = language === 'vi' ? supportItems : [
        { title: 'Email support', desc: 'Priority technical support and updates included in your plan.', meta: 'Response time: 4–24h' }, { title: 'Uptime monitoring', desc: 'Automated downtime monitoring and unusual-activity alerts.', meta: '24/7 (extended plans)' }, { title: 'Performance optimization', desc: 'Regular Core Web Vitals analysis and caching improvements.', meta: 'Monthly / quarterly' }, { title: 'Security and patching', desc: 'Malware scans and WordPress core/plugin updates.', meta: 'Scheduled and alert-based' }
    ];
    return (
        <section className="pt-32 pb-24 bg-white min-h-screen" id="support">
            <div className="container mx-auto px-4 max-w-5xl">
                <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.6 }} className="mb-12">
                    <h1 className="text-4xl font-extrabold mb-4">{t('support')}</h1>
                    <p className="text-gray-600 max-w-2xl">{language === 'vi' ? 'Thông tin tổng quan về phạm vi hỗ trợ kỹ thuật & kênh liên hệ cho khách hàng đang sử dụng dịch vụ DevenflyWeb.' : 'An overview of technical support coverage and contact channels for DevenflyWeb customers.'}</p>
                </motion.div>

                <div className="grid md:grid-cols-2 gap-8 mb-16">
                    {localizedItems.map((item, i) => (
                        <motion.div key={i} initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ duration: 0.5, delay: i * 0.05 }} className="border border-gray-100 rounded-xl p-6 hover:shadow-md transition-shadow bg-gray-50">
                            <h3 className="font-semibold text-lg mb-2 text-primary-600">{item.title}</h3>
                            <p className="text-gray-600 text-sm mb-2 leading-relaxed">{item.desc}</p>
                            <p className="text-xs text-gray-500">{item.meta}</p>
                        </motion.div>
                    ))}
                </div>

                <motion.div initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ duration: 0.6 }} className="bg-gray-50 rounded-xl p-8 border border-gray-200">
                    <h2 className="text-2xl font-semibold mb-4">{language === 'vi' ? 'Liên hệ trực tiếp' : 'Contact us directly'}</h2>
                    <ul className="space-y-3 text-gray-600">
                        <li className="flex items-center gap-3"><Mail size={18} className="text-primary-600" aria-hidden="true" /> Email kỹ thuật: support@wordpresspro.vn</li>
                        <li className="flex items-center gap-3"><Inbox size={18} className="text-primary-600" aria-hidden="true" /> Yêu cầu thay đổi: change@wordpresspro.vn</li>
                        <li className="flex items-center gap-3"><CircleAlert size={18} className="text-primary-600" aria-hidden="true" /> Sự cố khẩn cấp: urgent@wordpresspro.vn</li>
                    </ul>
                    <p className="text-sm text-gray-500 mt-6">{language === 'vi' ? 'Ghi chú: Một số hạng mục nâng cao yêu cầu gói bảo trì mở rộng.' : 'Note: Some advanced items require an extended maintenance plan.'}</p>
                </motion.div>
            </div>
        </section>
    );
};

export default Support;
